import { render, staticRenderFns } from "./voteDialog.vue?vue&type=template&id=16768c54&scoped=true&"
import script from "./voteDialog.vue?vue&type=script&lang=js&"
export * from "./voteDialog.vue?vue&type=script&lang=js&"
import style0 from "./voteDialog.vue?vue&type=style&index=0&id=16768c54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16768c54",
  null
  
)

export default component.exports